import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[onlyNumber]',
})
export class OnlynumberDirective {
  
  @HostListener('keydown', ['$event']) onInputChange(e) {
    let key = e.charCode || e.keyCode || 0;
    return (
      key === 8 ||
      key === 9 ||
      key === 46 ||
      (key >= 96 && key <= 105) ||
      (key >= 48 && key <= 57)
    );
  }
}
